import { getNonEmptyStringErrors, isNonEmptyString, NonEmptyString, StringUnion } from "Core/models/EmptyString";

export const validatePolicyNumberErrors = (policyNum: StringUnion) => {
    let res = getNonEmptyStringErrors(policyNum);
    if(res.value.length == 0 && !validatePolicyNumberLength(policyNum)) {
        res.value = ['policy number must be between 10 and 50 characters.'];
    }
  
    return res;
}

export const validatePolicyNumberLength = (policyNum: StringUnion) => {
    return policyNum.value.length >= 10 && policyNum.value.length <= 50; 
}

export const validatePolicyNumber = (num: StringUnion): num is NonEmptyString => {
    return isNonEmptyString(num) && validatePolicyNumberLength(num);
}